import React from 'react';
import { Alert, AlertType } from '../../../components/Alert';
import { appendQueryParam } from '../../../utils/url';

interface PropTypes {
  handleClose: () => void;
}

export default function CalendarDisconnectedAlert(props: PropTypes) {
  const reconnectUrl = appendQueryParam(
    '/account_settings/integrations',
    'state',
    window.location.href,
  );

  return (
    <Alert type={AlertType.Danger} clearable={true} onClose={props.handleClose}>
      {
        "Your calendar connection was lost. Scheduling features won't work until you "
      }
      <a
        href={reconnectUrl}
        target='_blank'
        className='text-info'
        rel='noreferrer'
      >
        reconnect
      </a>
      {'.'}
    </Alert>
  );
}
